import { api } from '@mmef/shared/api';
import type { NotificationItem } from '@mmef/shared/api';

export const notificationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    listNotifications: build.query<NotificationItem[], void>({
      query: () => '/me/notifications',
      providesTags: [{ type: 'Notifications', id: 'LIST' }],
    }),

    /** Separate from the feed: the badge renders on every page, the list only on one. */
    getUnreadCount: build.query<{ unread: number }, void>({
      query: () => '/me/notifications/unread-count',
      providesTags: [{ type: 'Notifications', id: 'UNREAD' }],
    }),

    markNotificationsRead: build.mutation<void, void>({
      query: () => ({ url: '/me/notifications/mark-read', method: 'POST' }),
      // Only the badge. Invalidating the list too meant opening the bell fetched the rows, marked
      // them read, then immediately fetched the same rows again — and the refetch cleared the
      // "New" markers you opened the panel to look at.
      invalidatesTags: [{ type: 'Notifications', id: 'UNREAD' }],
    }),
  }),
});

export const { useListNotificationsQuery, useGetUnreadCountQuery, useMarkNotificationsReadMutation } =
  notificationsApi;
